import i18next from 'i18next';
import { z } from 'zod';

export const repairCostingSchema = z.object({
  id: z.string().optional(),
  equipmentId: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('repairCosting:equipmentRequired'),
      });
    }
  }),
  damageId: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('repairCosting:damageRequired'),
      });
    }
  }),
  repairServiceId: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('repairCosting:repairServiceRequired'),
      });
    }
  }),
  cost: z.any().superRefine((data, ctx) => {
    if (data === '' || data === undefined || data === null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('repairCosting:costRequired'),
      });
    } else if (typeof data !== 'number' || isNaN(data)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('repairCosting:costRequired'),
      });
    }
  }),
  active: z.boolean().default(true),
});

export type TRepairCostingSchema = z.infer<typeof repairCostingSchema>;
